<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="availableFws.length > 0">
      <ODialogBar
        @close="$refs.dialog.$dismiss()"
        title="Escolha o firmware a ser enviado:"
      />
      <v-card-text class="pa-6">
        <v-autocomplete
          label="Firmware"
          v-model="selectedFw"
          :items="availableFws"
          item-text="name"
          item-value="id"
          return-object
          menu-props="closeOnContentClick"
        />
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @cancel="$refs.dialog.$dismiss()"
        txtApply="Enviar"
        @apply="$refs.dialog.$apply(selectedFw)"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { orderBy } from 'oderon-commons/src/utils'
import { Firmware } from '@/models'

export default {
  data() {
    return {
      isLoading: false,
      allFws: [],
      selectedFw: null
    }
  },
  computed: {
    availableFws() {
      return this.allFws.filter(x => x.deletedAt == null)
    }
  },
  methods: {
    open() {
      this.selectedFw = null
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let rows = await Firmware.findAll()
      this.allFws = orderBy(rows, [['id', 'desc']])
    }
  }
}
</script>

<style></style>
